const common = {
  // Nav
  "nav.guides": "首頁",
  "nav.clientSdk": "功能",
  "nav.serverApi": "文檔",
  "nav.download": "下載",
  "nav.android": "Android",
  "nav.ios": "iOS",
  "nav.pc": "PC 端",
  "nav.github": "GitHub",
  "nav.blog": "部落格",

  // Hero
  "hero.badge": "開源即時通訊",
  "hero.title1": "Build with",
  "hero.title2": "TupIM",
  "hero.desc": "TupIM 是IM技術專家打造的開源即時通訊組件，包括 IM 服務端和客戶端 SDK，靈活輕量易擴展。私有化部署，確保數據安全與私密性。",
  "hero.download": "下載",
  "hero.stat.devs": "開發者",
  "hero.stat.msgs": "消息/天",
  "hero.badge2.title": "端對端加密",
  "hero.badge2.desc": "消息安全有保障",

  // Features
  "features.label": "核心功能",
  "features.title": "一切你需要的通訊能力",
  "features.subtitle": "TupIM 提供完整的即時通訊解決方案，從消息到通話，從群組到文件，一站式滿足所有需求。",

  "feat.msg.title": "即時消息",
  "feat.msg.desc": "支持文字、表情、圖片、語音、視頻等多種消息類型，毫秒級延遲。",
  "feat.call.title": "音視頻通話",
  "feat.call.desc": "一對一或群組高清音視頻通話，穩定清晰，支持屏幕共享。",
  "feat.group.title": "群組聊天",
  "feat.group.desc": "創建並管理群組，支持至數千名成員，完善的群組管理功能。",
  "feat.file.title": "文件傳輸",
  "feat.file.desc": "快速安全地傳輸文件、照片和視頻，支持斷點續傳。",
  "feat.encrypt.title": "端對端加密",
  "feat.encrypt.desc": "所有消息端對端加密，私鑰僅存於用戶設備，保護隱私安全。",
  "feat.notify.title": "即時推送",
  "feat.notify.desc": "重要消息即時推送，支持多平台通知，從不錯過重要信息。",
  "feat.cross.title": "PC+APP支持",
  "feat.cross.desc": "一套 SDK 覆蓋 Web、Android、iOS端。",
  "feat.private.title": "私有化部署",
  "feat.private.desc": "支持私有服務器部署，數據完全自主掌控，企業級安全保障。",
  "feat.selfhost.title": "高性能架構",
  "feat.selfhost.desc": "基於 Go 語言構建，單機支持百萬級並發連接，彈性擴容。",

  "features.sdk.title": "全平台 SDK 支持",
  "features.sdk.desc": "無論你用什麼技術棧，TupIM 都為你準備好了 SDK",

  // Api hero section
  "api.hero.title1": "Build with",
  "api.hero.title2": "TupIM",
  "api.hero.desc": "TupIM 是IM技術專家打造的開源即時通訊組件，包括 IM 服務端和客戶端 SDK，非常適合將 IM 集成到应用中。支持私有化部署，數据安全有保障。",
  "api.hero.btn.start": "開始建造",
  "api.hero.btn.guide": "入門指南",

  // Api / Deploy section
  "api.open.title": "完全開源",
  "api.open.desc": "TupIM 服務端和所有 SDK 均在 GitHub 上開源，MIT 協議，可自由使用、修改和分發。",
  "api.open.contrib": "貢獻者",
  "api.open.btn": "查看 GitHub 倉庫",
  "api.deploy.title": "私有化部署",
  "api.deploy.desc": "幾行命令即可在自己的服務器上部署 TupIM，數據完全自主，無任何第三方依賴。",
  "api.deploy.f1": "Docker Compose 一鍵部署",
  "api.deploy.f2": "Kubernetes 集群部署支持",
  "api.deploy.f3": "完整的監控與日誌系統",
  "api.deploy.btn": "查看部署文檔",

  // Help
  "help.title": "有什麼我們可以幫助您的？",
  "help.demo.title": "查看 Demo",
  "help.demo.desc": "您可以前往下載供用戶測試的Apps或到兌換網站。",
  "help.demo.link": "立即前往 →",
  "help.support.title": "支持",
  "help.support.desc": "您可以在 TupIM 的代碼倉庫中找到或提交相關問題。",
  "help.support.link": "立即前往 →",
  "help.faq.title": "常見問題",
  "help.faq.desc": "瀏覽我們的常見問題解答節，找到常見問題的答案。",
  "help.faq.link": "查看問題 →",

  // Community
  "community.title": "加入社群",
  "community.desc": "與我們不斷壯大的社群互動，獲取最新更新、產品支持等。",
  "community.slack": "Slack →",

  // Download page
  "download.android.badge": "Android 應用",
  "download.android.title": "下載 TupIM Android 客戶端",
  "download.android.desc": "功能完整的即時通訊 Android 應用，支持文字、語音、視頻通話，以及群組聊天、文件傳輸等豐富功能。",
  "download.android.version": "最新版本",
  "download.android.size": "安裝包大小",
  "download.android.require": "系統要求",
  "download.android.require.val": "Android 5.0 及以上",
  "download.android.btn": "下載 APK",
  "download.android.qr": "掃碼下載",
  "download.android.qr.desc": "使用手機相機或二維碼掃描器掃描",
  "download.android.tip": "下載後請允許安裝來自未知來源的應用",
  "download.android.cta.title": "立即開始使用",
  "download.android.cta.desc": "免費下載，開始體驗安全、高效的即時通訊",

  "download.ios.badge": "iOS 應用",
  "download.ios.title": "下載 TupIM iOS 客戶端",
  "download.ios.desc": "為 iPhone 和 iPad 打造的即時通訊應用，提供流暢的原生體驗，支持所有核心通訊功能。",
  "download.ios.version": "最新版本",
  "download.ios.size": "安裝包大小",
  "download.ios.require": "系統要求",
  "download.ios.require.val": "iOS 13.0 及以上",
  "download.ios.btn": "App Store 下載",
  "download.ios.btn2": "TestFlight 測試版",
  "download.ios.qr": "掃碼下載",
  "download.ios.qr.desc": "使用 iPhone 相機掃描前往 App Store",
  "download.ios.tip": "支援 iPhone 及 iPad，iOS 15.0 以上版本",
  "download.ios.cta.title": "立即開始使用",
  "download.ios.cta.desc": "前往 App Store 免費下載，或加入 TestFlight 搶先體驗最新功能",

  // PC Download
  "download.pc.badge": "桌面端應用",
  "download.pc.title": "下載 TupIM 桌面版",
  "download.pc.desc": "功能完整的即時通訊桌面客戶端，支持 Windows、macOS 和 Linux，享受大屏幕帶來的極佳溝通體驗。",
  "download.pc.btn.windows": "下載 Windows 版",
  "download.pc.btn.mac": "下載 macOS 版",
  "download.pc.btn.open": "在瀏覽器中開啟",
  "download.pc.cta.btn": "開啟網頁版",
  "download.pc.browser.support": "支援的瀏覽器",

  "download.pc.tip": "免費 · 無需安裝，與所有設備實時同步。",
  "download.pc.features.title": "核心功能",
  "download.pc.features.subtitle": "為桌面端量身打造的高效通訊體驗",
  "download.pc.screenshots.title": "應用截圖",
  "download.pc.ss.chats": "聊天界面",
  "download.pc.ss.call": "視頻通話",
  "download.pc.ss.group": "群組聊天",
  "download.pc.ss.file": "文件管理",
  "download.pc.cta.title": "立即開始桌面體驗",
  "download.pc.cta.desc": "全平台免費下載，移動端與桌面端無縫同步",

  // Download features
  "download.feature.msg": "即時消息",
  "download.feature.msg.desc": "支持文字、表情、圖片、語音、視頻等多種消息類型",
  "download.feature.call": "音視頻通話",
  "download.feature.call.desc": "一對一或群組音視頻通話，清晰流暢",
  "download.feature.group": "群組聊天",
  "download.feature.group.desc": "創建並管理群組，支持至數千名成員",
  "download.feature.file": "文件傳輸",
  "download.feature.file.desc": "快速安全地傳輸文件、照片和視頻",
  "download.feature.encrypt": "端對端加密",
  "download.feature.encrypt.desc": "所有消息端對端加密，確保隱私安全",
  "download.feature.notify": "即時通知",
  "download.feature.notify.desc": "重要消息即時推送，從不錯過",
  "download.feature.shortcut": "鍵盤快捷鍵",
  "download.feature.shortcut.desc": "豐富的鍵盤快捷鍵與快速操作，大幅提升桌面端工作效率",

  // Download Section (homepage)
  "dl.label": "下載",
  "dl.title": "多平台下載",
  "dl.subtitle": "支持 Android、iOS 及所有主流桌面系統，消息在所有設備間即時同步。",
  "dl.sync": "全平台唔費下載，數據即時同步至所有設備。",
  "dl.android.title": "Android 版",
  "dl.android.desc": "功能完整的 Android 手機和平板應用，支持文字、語音、視頻通話、群組聊天等豐富功能。",
  "dl.android.req": "Android 5.0+",
  "dl.android.btn": "下載 Android 版",
  "dl.ios.title": "iPhone & iPad",
  "dl.ios.desc": "為 iPhone 和 iPad 打造的原生 iOS 體驗，流暢、快速、為 Apple 設備精心設計。",
  "dl.ios.req": "iOS 15.0+",
  "dl.ios.btn": "下載 iOS 版",
  "dl.pc.title": "桌面端",
  "dl.pc.desc": "支持 Windows 與 macOS 的強大桌面客戶端，大屏幕體驗配合高效快捷鍵操作。",
  "dl.pc.req": "Win / Mac",
  "dl.pc.btn": "下載桌面版",

  // Showcase
  "showcase.label": "深度解析",
  "showcase.title": "每一個功能，都為你精心設計",
  "showcase.subtitle": "從即時消息到音視頻通話，每個模塊都經過深度打磨，給你最流暢的通訊體驗。",

  "showcase.msg.title": "即時消息",
  "showcase.msg.tag": "消息系統",
  "showcase.msg.desc": "毫秒級延遲，支持全類型富媒體消息",
  "showcase.msg.p1": "支持文字、表情、圖片、語音、視頻、文件等 20+ 消息類型",
  "showcase.msg.p2": "消息已讀回執，雙方均可查看閱讀狀態",
  "showcase.msg.p3": "支持消息撤回、引用回複、@提及功能",
  "showcase.msg.p4": "離線消息自動同步，確保不錯過任何溝通",

  "showcase.call.title": "音視頻通話",
  "showcase.call.tag": "通話系統",
  "showcase.call.desc": "高清音視頻通話，穩定流暢不掉線",
  "showcase.call.p1": "支持一對一及多方群組音視頻通話",
  "showcase.call.p2": "內建屏幕共享功能，協作展示更方便",
  "showcase.call.p3": "自適應碼率，弱網環境也能保持通話穩定",
  "showcase.call.p4": "通話錄製功能，重要內容隨時回放",

  "showcase.group.title": "群組聊天",
  "showcase.group.tag": "群組管理",
  "showcase.group.desc": "靈活強大的群組管理，支持千人規模",
  "showcase.group.p1": "單個群組支持至 1000 名成員",
  "showcase.group.p2": "多級管理員角色，精細化權限控制",
  "showcase.group.p3": "群公告、群文件、群相冊一應俱全",
  "showcase.group.p4": "群成員禁言、踢出、加入審批等完善功能",

  "showcase.security.title": "安全加密",
  "showcase.security.tag": "隱私保護",
  "showcase.security.desc": "端對端加密，私鑰從不離開你的設備",
  "showcase.security.p1": "所有消息全程端對端加密，服務端無法讀取",
  "showcase.security.p2": "支持閱後即焚，消息閱讀後自動銷毀",
  "showcase.security.p3": "私有化部署，數據存儲在你自己的服務器",
  "showcase.security.p4": "定期第三方安全審計，保障系統安全",

  // Pricing
  "pricing.label": "方案選擇",
  "pricing.title": "選擇適合你的方案",
  "pricing.subtitle": "無論是個人開發者、成長中的團隊還是大型企業，TupIM 都為你準備了合適的方案。",
  "pricing.popular": "最受歡迎",
  "pricing.includes": "包含功能",
  "pricing.note": "所有方案均支持 7 天免費試用，無需綁定信用卡。如需定制化方案，請聯繫我們的銷售團隊。",

  "pricing.starter.name": "入門版",
  "pricing.starter.tag": "個人 / 小團隊",
  "pricing.starter.desc": "適合個人開發者和小型應用，快速體驗 TupIM 的核心通訊能力。",
  "pricing.starter.cta": "免費開始",
  "pricing.starter.f1": "最多 500 名活躍用戶",
  "pricing.starter.f2": "即時文字、圖片、語音消息",
  "pricing.starter.f3": "一對一音視頻通話",
  "pricing.starter.f4": "基礎群組（最多 50 人）",
  "pricing.starter.f5": "社區技術支持",
  "pricing.starter.m1": "多方群組通話",
  "pricing.starter.m2": "私有化部署",
  "pricing.starter.m3": "專屬技術支持",

  "pricing.pro.name": "專業版",
  "pricing.pro.tag": "成長型團隊",
  "pricing.pro.desc": "為快速成長的產品和團隊打造，解鎖全量功能，輕鬆應對萬人規模。",
  "pricing.pro.cta": "聯繫銷售",
  "pricing.pro.f1": "最多 10,000 名活躍用戶",
  "pricing.pro.f2": "全類型富媒體消息",
  "pricing.pro.f3": "多方群組音視頻通話",
  "pricing.pro.f4": "群組最多 1000 名成員",
  "pricing.pro.f5": "屏幕共享 & 通話錄製",
  "pricing.pro.f6": "端對端加密 & 閱後即焚",
  "pricing.pro.m1": "私有化部署",

  "pricing.enterprise.name": "企業版",
  "pricing.enterprise.tag": "大型企業",
  "pricing.enterprise.desc": "為超大規模應用和企業級需求而設計，完全私有化部署，數據完全自主。",
  "pricing.enterprise.cta": "獲取方案",
  "pricing.enterprise.f1": "無限活躍用戶",
  "pricing.enterprise.f2": "全量功能無上限",
  "pricing.enterprise.f3": "私有化部署 & 源碼授權",
  "pricing.enterprise.f4": "Kubernetes 集群高可用",
  "pricing.enterprise.f5": "SLA 99.99% 可用性保障",
  "pricing.enterprise.f6": "專屬技術顧問支持",
  "pricing.enterprise.f7": "定制化功能開發",

  // Docs page
  "docs.title": "文檔",
  "docs.group.start": "入門",
  "docs.group.core": "核心功能",
  "docs.group.dev": "開發者指南",
  "docs.nav.introduction": "產品介紹",
  "docs.nav.quickstart": "快速開始",
  "docs.nav.messaging": "即時消息",
  "docs.nav.calls": "音視頻通話",
  "docs.nav.groups": "群組管理",
  "docs.nav.encryption": "安全加密",
  "docs.nav.sdk": "SDK 集成",
  "docs.nav.deployment": "私有化部署",
  "docs.nav.api": "API 參考",
  "docs.toc": "目錄",
  "docs.copied": "已複製",
  "docs.copy": "複製",
  "docs.install": "安裝",
  "docs.init": "初始化",

  // Docs - Server group
  "docs.group.server": "服務器",
  "docs.nav.sfu": "SFU 帶寬計算",
  "docs.sfu.title": "如何計算 SFU 服務器組織的視頻會議帶寬",
  "docs.sfu.intro": "在 SFU（選擇性轉發單元）架構中，每個參與者將自己的流上傳到 SFU 服務器，服務器選擇性地轉發其他參與者的流。本文說明如何估算基於 SFU 的視頻會議帶寬需求。",
  "docs.sfu.arch.title": "SFU 架構概覽",
  "docs.sfu.arch.desc": "與 MCU（多點控制單元）不同，SFU 不混合流。每個參與者維護 N-1 條下行流（接收其他所有參與者的流）和 1 條上行流（發送自己的流）。這使 SFU 具有高度可擴展性，適合大型群組通話。",
  "docs.sfu.formula.title": "帶寬計算公式",
  "docs.sfu.formula.uplink": "上行（每用戶）：1 路視頻流上傳",
  "docs.sfu.formula.downlink": "下行（每用戶）：(N-1) 路視頻流下載",
  "docs.sfu.formula.total": "服務器總帶寬 = N × 上行碼率 + N × (N-1) × 下行碼率",
  "docs.sfu.params.title": "參考碼率參數",
  "docs.sfu.params.hd": "高清（720p）：上行 ~1.5 Mbps / 下行 ~1.2 Mbps",
  "docs.sfu.params.sd": "標清（480p）：上行 ~0.8 Mbps / 下行 ~0.6 Mbps",
  "docs.sfu.params.ld": "低清（240p）：上行 ~0.3 Mbps / 下行 ~0.25 Mbps",
  "docs.sfu.example.title": "計算示例",
  "docs.sfu.example.desc": "以下示例假設高清質量（720p），每位參與者上行 1.5 Mbps，下行 1.2 Mbps。",
  "docs.sfu.note.title": "注意事項",
  "docs.sfu.note.1": "需額外預留約 20% 的開銷用於協議頭、重傳及 RTCP 控制流量。",
  "docs.sfu.note.2": "啟用聯播（Simulcast）可讓 SFU 根據接收方自適應選擇流質量。",
  "docs.sfu.note.3": "音頻流通常每位參與者額外增加 50–100 kbps，需單獨計算。",
  "docs.sfu.note.4": "屏幕共享流可能需要額外 2–4 Mbps 的上行帶寬。",

  // Footer
  "footer.tagline": "TupIM\u00a0全方位守護你的隱私安全擁有私聊|羣聊|密信|建羣等功能",
  "footer.col.product": "產品",
  "footer.col.developer": "開發者",
  "footer.col.company": "公司",
  "footer.link.features": "功能特性",
  "footer.link.download": "下載",
  "footer.link.changelog": "更新日誌",
  "footer.link.docs": "文件",
  "footer.link.api": "API 參考",
  "footer.link.github": "GitHub",
  "footer.link.about": "關於我們",
  "footer.link.blog": "部落格",
  "footer.link.contact": "聯繫我們",
  "footer.copyright": "© 2024 TupIM. All rights reserved.",
  "footer.lang.zh": "繁體中文",
  "footer.lang.en": "English",

  // About page
  "about.badge": "關於我們",
  "about.hero.title": "打造下一代開源即時通訊基礎設施",
  "about.hero.desc": "TupIM 由一群深耕 IM 技術多年的工程師創立，致力於讓每位開發者都能以最低成本構建企業級即時通訊應用。我們堅信：通訊能力是每個應用的基石，而開源是讓這一切更美好的方式。",
  "about.hero.cta1": "聯繫我們",
  "about.hero.cta2": "查看 GitHub",

  "about.stat.devs": "全球開發者",
  "about.stat.msgs": "日均消息量",
  "about.stat.stars": "GitHub Stars",
  "about.stat.countries": "覆蓋國家",

  "about.mission.label": "使命與願景",
  "about.mission.title": "讓每個應用都擁有強大的通訊能力",
  "about.mission.p1": "即時通訊技術長期以來都是大廠的專利，中小團隊想要在自己的產品中加入 IM 功能，要麼依賴高昂的 SaaS 服務，要麼花費大量人力自研。TupIM 的出現，就是要打破這個局面。",
  "about.mission.p2": "我們提供完整的開源 IM 解決方案，包含服務端、Web SDK、iOS SDK 和 Android SDK，讓任何規模的團隊都能在數小時內完成集成，並完全掌控自己的數據。",
  "about.mission.p3": "我們的願景是：成為全球最受開發者信賴的開源即時通訊基礎設施，讓億萬用戶通過我們的技術進行更安全、更流暢的溝通。",

  "about.values.label": "核心理念",
  "about.values.title": "我們所相信和堅守的",
  "about.values.subtitle": "這些價值觀驅動著我們每一個技術決策和產品方向。",
  "about.value.opensource.title": "開源透明",
  "about.value.opensource.desc": "所有代碼在 GitHub 完全開放，MIT 協議，無黑箱，社區可自由審計、貢獻和分發。",
  "about.value.privacy.title": "隱私優先",
  "about.value.privacy.desc": "端對端加密是標配而非選配，私有化部署讓你的數據永遠不會落入第三方手中。",
  "about.value.performance.title": "極致性能",
  "about.value.performance.desc": "基於 Go 構建的高性能服務端，單節點支持百萬級並發，經過生產環境大規模驗證。",
  "about.value.community.title": "社區驅動",
  "about.value.community.desc": "產品方向由社區共同決定，每一個 Issue 和 PR 都是我們前進的動力。",
  "about.value.developer.title": "開發者體驗",
  "about.value.developer.desc": "詳盡的文檔、豐富的 Demo、完善的 SDK API，讓集成體驗盡可能簡單流暢。",
  "about.value.enterprise.title": "企業級可靠",
  "about.value.enterprise.desc": "Kubernetes 集群、多機房高可用、完整的監控告警，為企業生產環境保駕護航。",

  "about.timeline.label": "發展歷程",
  "about.timeline.title": "我們走過的每一步",
  "about.timeline.2020q1.date": "2020 Q1",
  "about.timeline.2020q1.title": "項目啟動",
  "about.timeline.2020q1.desc": "核心團隊成立，開始研究並設計高性能 IM 服務端架構，確定以 Go 作為主要技術棧。",
  "about.timeline.2020q3.date": "2020 Q3",
  "about.timeline.2020q3.title": "首個版本開源",
  "about.timeline.2020q3.desc": "OpenIM Server v1.0 在 GitHub 發布，首周獲得 500+ Star，吸引了第一批貢獻者。",
  "about.timeline.2021q2.date": "2021 Q2",
  "about.timeline.2021q2.title": "SDK 全平台覆蓋",
  "about.timeline.2021q2.desc": "iOS、Android、Web 三端 SDK 同步發布，開發者可以一鍵接入全平台 IM 能力。",
  "about.timeline.2022q1.date": "2022 Q1",
  "about.timeline.2022q1.title": "GitHub 破萬 Star",
  "about.timeline.2022q1.desc": "GitHub Stars 突破 10,000，成為 Go 語言開源 IM 領域最受歡迎的項目之一。",
  "about.timeline.2022q4.date": "2022 Q4",
  "about.timeline.2022q4.title": "企業版正式推出",
  "about.timeline.2022q4.desc": "推出企業版方案，提供私有化部署、專屬支持和 SLA 保障，服務首批企業客戶。",
  "about.timeline.2023q2.date": "2023 Q2",
  "about.timeline.2023q2.title": "音視頻通話模塊上線",
  "about.timeline.2023q2.desc": "基於 WebRTC 的高清音視頻通話模塊正式集成，支持一對一和群組通話。",
  "about.timeline.2024q1.date": "2024 Q1",
  "about.timeline.2024q1.title": "全球開發者突破 50,000",
  "about.timeline.2024q1.desc": "全球使用 TupIM 的開發者超過 5 萬，覆蓋 80+ 個國家和地區，日均消息量突破 2 億。",
  "about.timeline.2024q4.date": "2024 Q4",
  "about.timeline.2024q4.title": "TupIM 品牌升級",
  "about.timeline.2024q4.desc": "品牌全面升級為 TupIM，推出全新官網和文檔體系，持續打造更好的開發者生態。",

  "about.team.label": "核心團隊",
  "about.team.title": "認識背後的人",
  "about.team.subtitle": "一群熱愛開源、深耕 IM 技術的工程師，共同打造 TupIM。",
  "about.team.ceo.name": "陳宇軒",
  "about.team.ceo.role": "CEO & Co-Founder",
  "about.team.ceo.bio": "前大廠 IM 系統架構師，10 年即時通訊技術積累，主導設計了服務百萬並發的 IM 架構。",
  "about.team.cto.name": "王建明",
  "about.team.cto.role": "CTO & Co-Founder",
  "about.team.cto.bio": "Go 語言核心貢獻者，主導 OpenIM Server 架構設計，在高并發分布式系統領域有深厚積累。",
  "about.team.lead.name": "林思穎",
  "about.team.lead.role": "Lead Engineer",
  "about.team.lead.bio": "全棧工程師，負責 Web SDK 和前端架構，開源社區活躍貢獻者，GitHub 萬星項目維護者。",
  "about.team.sdk.name": "張偉",
  "about.team.sdk.role": "Mobile SDK Lead",
  "about.team.sdk.bio": "iOS/Android 雙端專家，主導移動端 SDK 設計，確保跨平台一致的開發體驗。",
  "about.team.infra.name": "劉強",
  "about.team.infra.role": "Infrastructure Lead",
  "about.team.infra.bio": "Kubernetes 專家，負責 TupIM 的雲原生化和私有化部署方案，服務數百企業用戶。",
  "about.team.design.name": "吳雨晴",
  "about.team.design.role": "Product Design Lead",
  "about.team.design.bio": "專注於開發者工具的 UX 設計，讓複雜的 IM 集成過程也能擁有流暢愉悅的體驗。",

  // Contact page
  "contact.badge": "聯繫我們",
  "contact.hero.title": "有問題？我們在這裡",
  "contact.hero.desc": "無論是技術問題、商務合作還是媒體採訪，選擇最適合的方式聯繫我們，我們會盡快回覆。",

  "contact.channel.support.title": "技術支持",
  "contact.channel.support.desc": "遇到 bug、SDK 集成問題或部署疑問？在 GitHub 提 Issue 或加入 Slack 社群，技術團隊會幫你解決。",
  "contact.channel.support.link1": "提交 GitHub Issue",
  "contact.channel.support.link2": "加入 Slack 社群",

  "contact.channel.business.title": "商務合作",
  "contact.channel.business.desc": "了解企業版方案、商業授權、定制開發合作？聯繫我們的商務團隊。",
  "contact.channel.business.link1": "發送商務郵件",
  "contact.channel.business.link2": "微信商務諮詢",

  "contact.channel.media.title": "媒體 & 公關",
  "contact.channel.media.desc": "記者採訪、產品評測、合作活動？請聯繫我們的公關團隊，我們很樂意配合。",
  "contact.channel.media.link1": "媒體聯繫郵件",
  "contact.channel.media.link2": "關注官方 Twitter",

  "contact.channel.community.title": "開源社群",
  "contact.channel.community.desc": "加入我們的開源社群，與全球開發者交流，獲取最新動態和技術分享。",
  "contact.channel.community.link1": "加入 Slack",
  "contact.channel.community.link2": "Follow GitHub",

  "contact.response.note": "一般回覆時間：技術問題 24 小時內 · 商務諮詢 1-2 個工作日 · 媒體需求 2-3 個工作日",

  "contact.faq.label": "常見問題",
  "contact.faq.title": "你可能想知道的",
  "contact.faq.f1.q": "TupIM 是完全免費的嗎？",
  "contact.faq.f1.a": "是的，TupIM 服務端和所有客戶端 SDK 均完全開源免費，MIT 協議。企業版提供私有化部署支持、SLA 保障和專屬技術服務，按需收費。",
  "contact.faq.f2.q": "如何快速開始集成 TupIM？",
  "contact.faq.f2.a": "你可以查看我們的快速開始文檔，使用 Docker Compose 5 分鐘內完成服務端部署，然後通過 npm 或 CocoaPods 安裝對應平台的 SDK 即可開始開發。",
  "contact.faq.f3.q": "數據安全和隱私如何保障？",
  "contact.faq.f3.a": "TupIM 支持私有化部署，所有數據存儲在你自己的服務器上，我們無法訪問你的用戶數據。同時所有消息均採用端對端加密傳輸，確保通訊安全。",
  "contact.faq.f4.q": "支持多大規模的並發？",
  "contact.faq.f4.a": "TupIM Server 基於 Go 的高性能架構，單節點可支持 100 萬+ 並發連接。通過 Kubernetes 集群水平擴展，可以支撐任意規模的業務需求。",
  "contact.faq.f5.q": "如何獲得企業版授權？",
  "contact.faq.f5.a": "請通過商務郵件或微信聯繫我們的銷售團隊，說明你的業務規模和需求，我們會為你定制最合適的方案和報價。",

  // Navbar about/contact
  "nav.about": "關於我們",
  "nav.contact": "聯繫我們",

  // Page title
  "page.title": "TupIM 全方位守護你的隱私安全擁有私聊|羣聊|密信|建羣等功能",
};

export default common;